import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import * as pdfjsLib from "pdfjs-dist";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { searchPlugin } from "@react-pdf-viewer/search";
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import React, { useEffect, useMemo, useRef, useState } from "react";
import texts from '../constants/components/pdfViewerText.js';
import { hasPdfDocument } from '../functions/pdfDocument';
import "./css/PdfViewer.css";
pdfjsLib.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js";
async function extractText(fileUrl) {
  const res = await fetch(fileUrl);
  const arrayBuffer = await res.arrayBuffer();
  const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
  const pdf = await loadingTask.promise;
  let text = "";
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    text += content.items.map(item => item.str).join(" ") + "\n\n";
  }
  return text;
}
export default function PdfViewer(props) {
  const { pdf } = props;
  const searchPluginInstance = searchPlugin();
  const [error, setError] = useState(null);
  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;

  const isMounted = useRef(true); // Use useRef for mounted status

  useEffect(() => {
    return () => {
      isMounted.current = false; // Set to false when component unmounts
    };
  }, []);

  const handleViewerError = (err) => {
    if (isMounted.current) { // Only update state if component is mounted
      setError(err);
    }
  };
  const handleLoadSuccess = (pdfDocument) => {
    console.log('PDF loaded with number of pages:', pdfDocument.numPages);
  };
  const [accessibleText, setAccessibleText] = useState('');
  const lastDocumentoUrl = useRef(null); // Use useRef directly

  const documentoUrl = useMemo(() => Array.isArray(pdf) && pdf.length > 0 ? pdf[0].documento : null, [pdf]);
  const canRenderDocument = hasPdfDocument(documentoUrl);

  useEffect(() => {
    if (canRenderDocument && documentoUrl !== lastDocumentoUrl.current) {
      lastDocumentoUrl.current = documentoUrl;
      extractText(documentoUrl)
        .then(text => {
          if (isMounted.current) { // Check isMounted.current before updating state
            setAccessibleText(text);
          }
        })
        .catch(error => {
          console.error("Error extracting text for accessibility:", error);
          if (isMounted.current) { // Check isMounted.current before updating state
            setAccessibleText(texts.errorMessages.errorExtraerTexto); // Provide a fallback message
          }
        });
    }
  }, [canRenderDocument, documentoUrl]);
  const isMobile = window.innerWidth < 900;
  return (
    <div role="region" aria-label="Visor de documento PDF" className="pdfContainer">
      {!isMobile && canRenderDocument && (
        <Worker
          workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
        >
          <div className="viewerAndToolbarContainer">
            <div className="viewerContainer">
              <div className="textPdfViewer">
                {pdf[0].docname?.replace(".pdf", "") || "Documento sin nombre"}
              </div>
              <Viewer
                fileUrl={documentoUrl}
                plugins={[toolbarPluginInstance, searchPluginInstance]}
                onError={handleViewerError}
                defaultScale={1}
              />
            </div>
            <div className="toolbarContainer">
              <Toolbar>
                {(props) => {
                  const {
                    CurrentPageInput,
                    GoToNextPage,
                    GoToPreviousPage,
                    NumberOfPages,
                    /* ShowSearchPopover, */
                    ZoomIn,
                    ZoomOut,
                  } = props;
                  return (
                    <>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div className="currentPageInput">
                          <CurrentPageInput />
                        </div>
                        <div className="itemsToolbar">
                          <NumberOfPages />
                        </div>

                        <div className="itemsToolbar">
                          <GoToPreviousPage>
                            {(props) => (
                              <button {...props} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                <KeyboardArrowLeftIcon sx={{ color: "white", transform: "rotate(90deg)" }} />
                              </button>
                            )}
                          </GoToPreviousPage>
                        </div>

                        <div className="itemsToolbar">
                          <GoToNextPage>
                            {(props) => (
                              <button {...props} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                <KeyboardArrowRightIcon sx={{ color: "white", transform: "rotate(90deg)" }} />
                              </button>
                            )}
                          </GoToNextPage>
                        </div>
                        <div className="itemsToolbar">
                          <ZoomOut />
                        </div>
                        <div className="itemsToolbar">
                          <ZoomIn />
                        </div>
                        {/* <div style={{ padding: '0px 2px' }}>
                          <ShowSearchPopover />
                        </div> */}
                      </div>
                    </>
                  );
                }}
              </Toolbar>
            </div>
          </div>
        </Worker>
      )}
      {isMobile && canRenderDocument &&
        (<Worker
          workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
        >
          <div className="viewerAndToolbarContainer">
            <div className="viewerContainer">
              <div className="textPdfViewerMobile">
                {pdf[0].docname?.split(".pdf") || "Documento sin nombre"}
              </div>
              <div style={{ maxHeight: "65vh", overflowY: "auto" }}>
                <Viewer
                  fileUrl={documentoUrl}
                  plugins={[toolbarPluginInstance, searchPluginInstance]}
                  onError={handleViewerError}
                  defaultScale={0.5}
                  onLoadSuccess={handleLoadSuccess}
                />
              </div>
              <div className="toolbarContainerMobile">
                <Toolbar>
                  {(props) => {
                    const {
                      CurrentPageLabel,
                      NumberOfPages,
                    } = props;
                    return (
                      <>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <div className="currentPageInputMobile">
                            <CurrentPageLabel />
                          </div>
                          <p style={{ fontFamily: "robotoMedium", fontSize: "14px", marginRight: "3px", color: "white" }}>de</p>
                          <div className="itemsToolbar">
                            <NumberOfPages />
                          </div>
                        </div>
                      </>
                    );
                  }}
                </Toolbar>
              </div>
            </div>
          </div>
        </Worker>)
      }
      <div
        id="accessibleText"
        className="sr-only"
        role="region"
        aria-live="polite"
        lang="es"
        tabIndex={0}
        aria-label="Transcripción accesible del documento"
      >
        {accessibleText || "El contenido accesible no está disponible."}
      </div>
      {error && (
        <div className="errorMessage">
          {texts.errorMessages.errorCargarPdf} {error.message}
        </div>
      )}
    </div>
  );
}
